import { render } from "./RemoteController2.vue?vue&type=template&id=2823d9a3&scoped=true"
import script from "./RemoteController2.vue?vue&type=script&lang=js"
export * from "./RemoteController2.vue?vue&type=script&lang=js"

import "./RemoteController2.vue?vue&type=style&index=0&id=2823d9a3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2823d9a3"]])

export default __exports__